import { render } from "./ArticleCta.vue?vue&type=template&id=44ce4a41&scoped=true"
import script from "./ArticleCta.vue?vue&type=script&lang=js"
export * from "./ArticleCta.vue?vue&type=script&lang=js"

import "./ArticleCta.vue?vue&type=style&index=0&id=44ce4a41&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-44ce4a41"

export default script